<claas-dropdown-simple
  [size]="dropdownSize.SMALL"
  [label]="'pia.features.product-overview.yearSelect.label' | translate"
  [options]="optionsAsStrings"
  [defaultOption]="defaultOptionAsString"
  (changed)="handleFilterSelectChange($event)"
></claas-dropdown-simple>
